import { useQuery } from '@tanstack/react-query'
import { getAllFeatureFlags } from '@/lib/get-feature-flag'
import { useOidc } from '@/features/oidc/oidc'

export type FeatureFlagKey =
  | 'nova-release-activity-reminder'
  | 'eclipse-release-coins-animation'
  | 'nova-release-ribbon-tokens-prompt'
  | 'eclipse-release-in-product-popups'
  | 'eclipse-release-jackpots-tickers-animation'
  | 'eclipse-release-jackpot-game-info-drawer-animation'
  | 'eclipse-release-jackpot-game-tile-animation'

const getAllFeatureFlagsQueryKey = (userId?: string) => [
  'all-feature-flags',
  userId,
]

export const useFeatureFlagsOptions = () => {
  const { decodedIdToken } = useOidc()
  const userId = decodedIdToken?.['pam-aid']

  return {
    queryKey: getAllFeatureFlagsQueryKey(userId),
    queryFn: () => getAllFeatureFlags({ userId }),
  }
}
export const useFeatureFlags = () => {
  const options = useFeatureFlagsOptions()

  return useQuery({
    ...options,
  })
}

export const useFeatureFlag = ({ flagKey }: { flagKey: FeatureFlagKey }) => {
  const { data, isPending } = useFeatureFlags()

  return {
    ...(data?.[flagKey] ?? { enabled: false, variant: { value: 'off' } }),
    isPending,
  }
}
